//@flow
import { YES,NO } from '../../Utils/variables'
import type { ReviewAnswer } from '../../components/QualityReview/flowTypes'

export const getReviewOutcome=(formData: any,reviewQuestions: Array<any>)=>{
    let reviewAnswers:Array<ReviewAnswer> = []

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect' && formData[question.elementId]){
            const newReviewAnswer:ReviewAnswer={
                elementId: question.elementId,
                questionText: question.questionText,
                answer: formData[question.elementId],
                subAnswers: []
            }
            reviewAnswers.push(newReviewAnswer)
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_Yes`
            const noElement = `${question.elementId}_No`

            let newReviewAnswer:ReviewAnswer={
                elementId: question.elementId,
                questionText: question.questionText,
                answer: '',
                subAnswers: []
            }

            if (formData[noElement]){
                newReviewAnswer.answer = NO
                reviewAnswers.push(newReviewAnswer)   
            }else {
                newReviewAnswer.answer = YES
                question.yesSubAnswers.map(subAnswer=>{
                    if (formData[subAnswer.field]){
                        newReviewAnswer.subAnswers.push(subAnswer.field)
                    }
                })
                reviewAnswers.push(newReviewAnswer) 
            }
        }
    })

    return reviewAnswers
}


// WEBPACK FOOTER //
// ./src/redux/demeter/submitFormData.js